import React from 'react';
import {List, Datagrid, TextField, EditButton} from 'react-admin';

const ShowEditButton = ({record, basePath}) => {
  return record.id !== 0 && <EditButton basePath={basePath} record={record} />;
};
export const ServiceCategoryList = (props) => (
  <List title=" Service Category" {...props}>
    <Datagrid>
      <TextField source="serviceCategoryName" label="Service Category Name" />
      <TextField source="serviceCode" label="Service Code" />
      <TextField source="profitPercentage" label="Profit Percentage" />
      <TextField source="commissionThreshold" label="Commission Threshold Amount" />
      <TextField source="fixedCommission" label="Fixed Commission Above Threshold" />
      <ShowEditButton />
    </Datagrid>
  </List>
);
export default ServiceCategoryList;
